<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 01 API Response</h1>

      <div>
        <b-row>
          <b-col md="3">
            <label>Interface Name</label>
            <b-form-input
              :formatter="capitalizeAll"
              disabled
              id="interfaceName"
              name="interfaceName"
              v-model="interfaceName"
            ></b-form-input
          ></b-col>
          <b-col md="3">
            <label>IGM Number (2272354)</label>
            <b-form-input
              :formatter="capitalizeAll"
              id="igmNumber"
              name="igmNumber"
              v-model="igmNumber"
            ></b-form-input
          ></b-col>
          <b-col md="3">
            <b-button
              v-if="interfaceName && igmNumber"
              @click="getAllPCS01Func()"
              size="sm"
              variant="info"
              style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
              >Fetch</b-button
            >
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="12" class="mt-1 mb-1">
            <div
              class="shipper-table"
              v-if="getAllPcs01 && getAllPcs01.length > 0 && headers.length > 0"
            >
              <table>
                <thead>
                  <tr>
                    <th class="purple-gradient">SN</th>
                    <th
                      v-for="(header, index) in headers"
                      :key="index"
                      class="purple-gradient"
                    >
                      {{ formatHeader(header) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in getAllPcs01" :key="index" class="fade-in">
                    <td>{{ index + 1 }}</td>
                    <td v-for="(header, index) in headers" :key="index">
                      {{ item[header] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS01Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      interfaceName: "CHPOI03",
      igmNumber: "",
      headers: [],
      getAllPcs01: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },
  computed: {
    // headers() {
    //   if (this.getAllPcs01.response && this.getAllPcs01.response.length > 0) {
    //     return Object.keys(this.getAllPcs01.response[0]);
    //   }
    //   return [];
    // },
  },
  methods: {
    formatHeader(header) {
      return header.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    },
    async getAllPCS01Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs01 = null;

      if (this.interfaceName && this.igmNumber) {
        payload = {
          itemCode: "PCS01",
          funcUrl: "PCS/01",
          interfaceName: this.interfaceName,
          igmNumber: this.igmNumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("getAllPcs01 PS =>", data.getAllPcs01.response.response);
              if (data.getAllPcs01.response.response) {
                this.getAllPcs01 = data.getAllPcs01.response.response;
                console.log("PS=>", this.getAllPcs01[0].response);
                if (
                  this.getAllPcs01[0].response &&
                  this.getAllPcs01[0].response.length > 0
                ) {
                  this.headers = Object.keys(this.getAllPcs01[0].response[0]);
                  this.getAllPcs01 = this.getAllPcs01[0].response;
                  // console.log("PS=>",Object.keys(this.getAllPcs01[0].response))
                }
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs01 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
/* Global Styles */
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  background: #f0f2f5;
}

/* Container */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-height: 100vh;
}

/* Loader */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* Card */
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  /* max-width: 1800px; */
  padding: 20px;
  animation: fadeIn 0.5s ease-in-out;
}

/* Navbar */
.navbar {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  background: linear-gradient(45deg, #ff6f61, #ff9068, #ffb086, #ffc494);
  color: #fff;
  padding: 15px 20px;
  border-radius: 8px 8px 0 0;
}

.navbar-brand {
  font-size: 1.5em;
  font-weight: bold;
  /* color: #fff; */
}

/* Form */
.form {
  padding: 20px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.form-col {
  flex: 1;
  min-width: 45%;
  margin-right: 10px;
  margin-bottom: 10px;
}

.form-col:last-child {
  margin-right: 0;
}

label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

input,
textarea {
  width: 100%;
  padding: 18px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: border-color 0.3s;
}

input:focus,
textarea:focus {
  border-color: #2575fc;
}

.error {
  color: red;
  font-size: 9px;
}

/* Centered Buttons */
.centered-buttons {
  display: flex;
  justify-content: center;
}

.save-button,
.back-button {
  background: linear-gradient(45deg, #ff6f61, #ff9068, #ffb086, #ffc494);
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: background 0.3s;
  /* display: flex; */
  align-items: center;
}

.save-button:hover,
.back-button:hover {
  background: linear-gradient(45deg, #ffb086, #ffc494, #ff9068, #ff6f61);
}

.ml-2 {
  margin-left: 10px;
}

/* Alert Dialog */
.alert-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}

.alert-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.alert-content p {
  margin-bottom: 20px;
}

.alert-content button {
  background: #2575fc;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: background 0.3s;
}

.alert-content button:hover {
  background: #6a11cb;
}

/* Shipper Table */
.shipper-table {
  position: relative;
  margin-bottom: 20px;
  overflow-x: auto; /* Ensure horizontal scrollbar is visible */
  overflow-y: visible; /* Allow vertical overflow */
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  /* position: relative; */
  /* z-index: 1000; Set a high z-index value */
}

th,
td {
  padding: 2px 2px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

thead th {
  background-color: #f2f2f2;
  font-weight: bold;
  text-align: center;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Animated Row */
/* .fade-in {
  animation: fadeInAnimation 0.5s ease-in-out forwards;
  opacity: 0;
  transform: translateY(20px);
} */

/* Purple Gradient for Table Header */
.purple-gradient {
  background: linear-gradient(to right, #9c27b0, #673ab7);
  color: #fff;
}

/* Adjust the dropdown menu style */
.model-list-select .dropdown-menu {
  position: absolute !important; /* Override any fixed or relative positioning */
  z-index: 1000; /* Ensure it appears above other elements */
  top: auto; /* Ensure dropdown position is relative to the container */
  left: 0;
  right: 0;
  transform: translateY(-100%); /* Move it above the input */
  margin-top: 0; /* Remove any margin that might push it down */
}

/* Optional: Additional styles to enhance appearance */
.model-list-select .dropdown-menu > .dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.model-list-select .dropdown-menu > .dropdown-item:hover {
  background-color: #f0f0f0;
}

/* Ensure table cells allow overflow */
td {
  overflow: visible !important;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// PCS01_ResponseDisplay.vue?f1405f30